import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';
import moment from 'moment'

import StoreS3 from '../../util/StoreS3.jsx';
import InputTextBar from '../../util/InputTextBar.jsx';
import Common from '../../util/Common.jsx';

import Workset from "./Workset.jsx"

const ContentWrapper = styled.div`
    margin: 0;
`;

const WorksetsTitle = styled.div`
    display: inline-block;
    padding: 0.35rem 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.1rem;
    background-color: #999999;
    color: white;
    font-size: 1.1rem;
    border-radius: 0.25rem;
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
`;

const GenericButton = styled.button`
    padding: 0.15rem 0.25rem;
    margin-left: 0.25rem;
    cursor: pointer;
`;

export class ListWorksets extends Component {

    static propTypes = {
        year: PropTypes.number.isRequired
    }

    state = {
        adding_name: false,
        workset_files: []
    };

    componentDidMount() {
        this.get_worksets();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.year !== this.props.year) {
            this.setState({workset_files: []})
            this.get_worksets();
        }
    }

    async get_worksets() {
        const workset_files = await StoreS3.list_files('catalog/' + this.props.year);
        this.setState({workset_files: workset_files.Contents});
    }

    add_workset() {
        this.setState({adding_name: true})
    }

    click_new_workset_ok = (new_name) => {
        const slug_form = Common.slugify(new_name);
        if (!slug_form.length) {
            return;
        }
        const new_workset_name = new_name.trim();
        if (new_workset_name.length) {
            const path = "catalog/" + this.props.year + "/" + slug_form + ".json";
            const data = {
                title: new_workset_name,
                slug: slug_form,
                path: path,
                type: "workset",
                value: "",
                index: this.state.workset_files.length + 1,
                created: moment().format(),
            }
            StoreS3.put_file(path, JSON.stringify(data, undefined, 2));
            const that = this;
            setTimeout(function () {
                that.get_worksets();
            }, 500);
        }
        this.setState({adding_name: false})
    }

    click_new_workset_cancel = () => {
        this.setState({adding_name: false})
    }

    render() {
        const add_workset = <GenericButton onClick={e => this.add_workset()}>add...</GenericButton>;
        const edit_name = !this.state.adding_name ? '' :
            <InputTextBar
                callback_ok={this.click_new_workset_ok}
                callback_cancel={this.click_new_workset_cancel}/>
        const worksets = this.state.workset_files.sort((a, b) => a.Key.localeCompare(b.Key))
            .map((workset_file, index) =>
                <Workset
                    key={"workset_" + this.props.year + "_" + index}
                    workset_file={workset_file}/>);
        return <ContentWrapper>
            <WorksetsTitle>worksets for the year {this.props.year}</WorksetsTitle>
            {add_workset}
            {edit_name}
            {worksets}
        </ContentWrapper>
    }
}

export default ListWorksets;
